import { Button, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, FormHelperText, Grid, InputLabel, Select, TextField } from '@material-ui/core';
import { useFormik } from 'formik';
import React, { useCallback, useContext, useEffect } from 'react';
import { TablaSociedadesContext } from './tablaSociedades';
import * as yup from 'yup';

const validationSchema = yup.object({
  sociedad: yup.string().required(),
});

export default function DialogoCRUDSociedades() {
  const { openDialogoCRUD, setOpenDialogoCRUD, tituloDialogo, handleAceptar, disableEditing, initialValues } =
    useContext(TablaSociedadesContext);

  const handleClose = () => setOpenDialogoCRUD(false);

  const formik = useFormik({
    initialValues,
    onSubmit: handleAceptar,
    validationSchema,
  });

  const { values, errors, touched, handleSubmit, handleChange, resetForm } = formik;

  const resetFormik = useCallback(() => {
    resetForm({ values: initialValues });
  }, [initialValues, resetForm]);

  useEffect(() => {
    resetFormik();
  }, [resetFormik]);

  return (
    <Dialog open={openDialogoCRUD} maxWidth="md" fullWidth>
      <DialogTitle>{tituloDialogo}</DialogTitle>
      <form autoComplete="off" onSubmit={handleSubmit}>
        <DialogContent>
          <Grid container spacing={2}>
            <Grid item xs>
              <TextField
                name="sociedad"
                label="Nombre Sociedad"
                value={values.sociedad}
                onChange={handleChange}
                variant="outlined"
                fullWidth
                disabled={disableEditing}
                error={errors.sociedad && touched.sociedad ? true : false}
                helperText={errors.sociedad && touched.sociedad ? errors.sociedad : ''}
              />
            </Grid>
            <Grid item xs>
              <TextField
                name="rut"
                label="Rut"
                value={values.rut}
                onChange={handleChange}
                variant="outlined"
                fullWidth
                disabled={disableEditing}
                error={errors.rut && touched.rut ? true : false}
                helperText={errors.rut && touched.rut ? errors.rut : ''}
              />
            </Grid>
          </Grid>
          <Grid container spacing={2}>
            <Grid item xs>
              <TextField
                name="giro"
                label="Giro"
                value={values.giro}
                onChange={handleChange}
                variant="outlined"
                fullWidth
                disabled={disableEditing}
                error={errors.giro && touched.giro ? true : false}
                helperText={errors.giro && touched.giro ? errors.giro : ''}
              />
            </Grid>
            <Grid item xs>
              <TextField
                name="descripcion"
                label="Descripción"
                value={values.descripcion}
                onChange={handleChange}
                variant="outlined"
                fullWidth
                disabled={disableEditing}
                error={errors.descripcion && touched.descripcion ? true : false}
                helperText={errors.descripcion && touched.descripcion ? errors.descripcion : ''}
              />
            </Grid>
            <Grid item xs>
              <FormControl
                variant="outlined"
                margin="none"
                fullWidth
                error={touched.tipo_leasing && errors.tipo_leasing && Boolean(errors.tipo_leasing)}
              >
                <InputLabel shrink={true}>Tipo de Leasing</InputLabel>
                <Select native name="tipo_leasing" label="tipo_leasing" onChange={handleChange} value={values.tipo_leasing}>
                  {/* <option value=""></option> */}
                  <option value="financiero">Leasing Financiero</option>
                  <option value="operativo">Leasing Operativo</option>                  
                </Select>
                <FormHelperText>{touched.tipo_leasing && errors.tipo_leasing ? errors.tipo_leasing : ''}</FormHelperText>
              </FormControl>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} variant="outlined" color="primary">
            Cancelar
          </Button>
          <Button type="submit" variant="contained" color="primary">
            Aceptar
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
}
